import { render, staticRenderFns } from "./DmGlamiConsent.vue?vue&type=template&id=a0ac1e64&scoped=true&"
import script from "./DmGlamiConsent.vue?vue&type=script&lang=js&"
export * from "./DmGlamiConsent.vue?vue&type=script&lang=js&"
import style0 from "./DmGlamiConsent.vue?vue&type=style&index=0&id=a0ac1e64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ac1e64",
  null
  
)

export default component.exports